(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
	$(".footer-nav-news").click(function(){
        $(".modal-newsletter__bg").fadeToggle("fast");
        $(".modal-newsletter__inner").fadeToggle("fast");
        $("body").toggleClass("no-scroll");
	});
    $(".modal-newsletter__close").click(function(){
        $(".modal-newsletter__bg").fadeToggle("fast");
        $(".modal-newsletter__inner").fadeToggle("fast");
        $("body").toggleClass("no-scroll");
	});
    $(".modal-newsletter__bg").click(function(){
        $(".modal-newsletter__bg").fadeToggle("fast");
        $(".modal-newsletter__inner").fadeToggle("fast");
        $("body").toggleClass("no-scroll");
	});
});

$(document).ready(function(){
$('body.index #shopify-section-template--19500252463435__c210cb87-22f1-4fa1-ae20-82d0fa64fd24 slider-component ul.product-grid li.grid__item').hover(function(){
    $("body.index #shopify-section-template--19500252463435__c210cb87-22f1-4fa1-ae20-82d0fa64fd24 slider-component ul.product-grid li.grid__item").toggleClass("hover-blur");
});
});
  


function handleMarquee(){
  const marquee = document.querySelectorAll('#shopify-section-template--19500252463435__3f714784-e2e9-4015-90aa-8c4eb58ee585 .rich-text__wrapper');
  let speed = 1;
  let lastScrollPos = 0;
  let timer;

  marquee.forEach(function(el){
    // stop animation on mouseenter
    mouseEntered = false;
    document.querySelector('#shopify-section-template--19500252463435__3f714784-e2e9-4015-90aa-8c4eb58ee585 .rich-text__blocks').addEventListener('mouseenter', function() {
      mouseEntered = true;
    })
    document.querySelector('#shopify-section-template--19500252463435__3f714784-e2e9-4015-90aa-8c4eb58ee585 .rich-text__blocks').addEventListener('mouseleave', function() {
      mouseEntered = false
    })

    const container = el.querySelector('#shopify-section-template--19500252463435__3f714784-e2e9-4015-90aa-8c4eb58ee585 .rich-text__blocks');
    const content = el.querySelector('#shopify-section-template--19500252463435__3f714784-e2e9-4015-90aa-8c4eb58ee585 .rich-text__blocks > *');
    //Get total width
    const  elWidth = content.offsetWidth;
    
    //Duplicate content
    let clone = content.cloneNode(true);
    container.appendChild(clone);
    
    let progress = 1;
    function loop(){
      if (mouseEntered === false) {progress = progress-speed;} 
      if (progress <= elWidth*-1) {progress=0;}
      container.style.transform = 'translateX(' + progress + 'px)';
      window.requestAnimationFrame(loop);
    }
    loop();
  });
  
  function handleSpeedClear(){
    speed = 1;
  }
};

handleMarquee();

function handleMarqueeBottom(){
  const marquee = document.querySelectorAll('#shopify-section-template--19500252463435__00b9fc6f-548e-4ebd-8f0e-6f628758e28a .rich-text__wrapper');
  let speed = 2;
  let lastScrollPos = 0;
  let timer;

  marquee.forEach(function(el){
    // stop animation on mouseenter
    mouseEntered = false;
    document.querySelector('#shopify-section-template--19500252463435__00b9fc6f-548e-4ebd-8f0e-6f628758e28a .rich-text__blocks').addEventListener('mouseenter', function() {
      mouseEntered = true;
    })
    document.querySelector('#shopify-section-template--19500252463435__00b9fc6f-548e-4ebd-8f0e-6f628758e28a .rich-text__blocks').addEventListener('mouseleave', function() {
      mouseEntered = false
    })

    const container = el.querySelector('#shopify-section-template--19500252463435__00b9fc6f-548e-4ebd-8f0e-6f628758e28a .rich-text__blocks');
    const content = el.querySelector('#shopify-section-template--19500252463435__00b9fc6f-548e-4ebd-8f0e-6f628758e28a .rich-text__blocks > *');
    //Get total width
    const  elWidth = content.offsetWidth;
    
    //Duplicate content
    let clone = content.cloneNode(true);
    container.appendChild(clone);
    
    let progress = 1;
    function loop(){
      if (mouseEntered === false) {progress = progress-speed;} 
      if (progress <= elWidth*-1) {progress=0;}
      container.style.transform = 'translateX(' + progress + 'px)';
      window.requestAnimationFrame(loop);
    }
    loop();
  });
  
  function handleSpeedClearBottom(){
    speed = 2;
  }
};

handleMarqueeBottom();


var min = -18;
var max = 18;
function rotateLetters(word) {
  var words = word.split("");
  var elements = new Array;
  $.each(words, function(index, value) {
    var random = Math.floor(Math.random() * (max - min + 1) + min);
    elements.push("<span class='letter' style='display: inline-block; transform: rotate(" + random + "deg)'>" + words[index] + "</span>");
  });
  return elements;
}
$('.rotateletters').each(function() {
  $(this).html(rotateLetters($(this).text()));
});
$('#collection_menu_gift li a').each(function() {
  $(this).html(rotateLetters($(this).text()));
});

// Toggle btn category

document.addEventListener('click', function (e) {
  const overlay = document.querySelector('.overlay-categories');
  if (!overlay) return;

  if (e.target.closest('.btn-categories-toggle')) {
    overlay.classList.toggle('is-active');
    document.body.classList.toggle('collection-overflow-hidden');
  }

  if (e.target.closest('.btn-categories-close')) {
    overlay.classList.remove('is-active');
    document.body.classList.remove('collection-overflow-hidden');
  }

  if (e.target === overlay) {
    overlay.classList.remove('is-active');
    document.body.classList.remove('collection-overflow-hidden');
  }
});

// Variations label

document.addEventListener('DOMContentLoaded', function () {
  const showLegend = () => {
    document.querySelectorAll('legend.avis-option-name').forEach(el => {
      el.removeAttribute('style'); 
    });
  };

  showLegend();

  const observer = new MutationObserver(showLegend);
  observer.observe(document.body, { childList: true, subtree: true });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about"]) return;
  try {
    
  $("#MainContent #shopify-section-template--19677960569163__d9f0c36f-0e48-4cfe-ac8e-c570adedc39e .rich-text").append("<img class='about-img' src='https://cdn.shopify.com/s/files/1/0772/5291/9627/files/binya_about.gif'/>");

  } catch(e) { console.error(e); }
})();
})();
